import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "../index.css";

const Hero = () => {
  return (
    <section id="Profile" className="py-3">
      <div className="container">
        <div className="pt-5 mt-4">
          <div className="row align-items-center justify-content-start ">

            {/* Profile Image */}
            <div className="col-auto text-center text-md-start">
              <img
                src="/profile.png"
                alt="Profile"
                className="profile-img rounded-circle"
              />
            </div>

            {/* Hero Content */}
            <div className="col-md-10 ">
              <h1 className="fw-bold mb-2">
               {/*   Hi <span role="img" aria-label="wave">👋</span>, I'm */}<strong>Salman Saeed</strong>{" "}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="12" fill="#3498db" />
                  <path d="M7 12l3 3 6-6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </h1>
              <p className="lead mb-2">Financial Analyst</p>

              {/* Social Media Icons */}
              <div className="d-flex">
                <a href="https://www.linkedin.com/in/salmansaeed21"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon me-3 fs-4">
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
                <a href="mailto:salmansaeed2112@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon fs-4">
                  <FontAwesomeIcon icon={faEnvelope} />
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
